import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/
import CommonButton from '../components/CommonButton';

class SearchMatchingDemandSupply extends Component {

    render = () => {
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation } = props;

        let { academy_id, target_industries_id, demand_edu_level_id, position_id, demand_skill_type_id, supply_exceeds_demand_flag } = Searchs; 

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row className="ms-2 me-2">
                    <Col md={12} className="custom-search-panel-body">
                        <Row className="mt-3">
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{academy_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={academy_id}
                                        option={{source: 'db', data: Masterbase?.academy}}
                                        hr={false}
                                        callback={(e, element) => { onInputChange(e, element);}}
                                    />
                                </InputGroup>
                            </Col> 
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{demand_edu_level_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={demand_edu_level_id}
                                        option={{source: 'db', data: Masterbase?.education_level}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>                                     
                        </Row>

                        <Row>
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{demand_skill_type_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={demand_skill_type_id}
                                        option={{source: 'db', data: Masterbase?.skills_set_type}}
                                        hr={false}
                                        callback={(e, element) => {
                                            onInputChange(e, element);
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{position_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={position_id}
                                        option={{source: 'db', data: Masterbase?.position}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                        </Row>

                         <Row>
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{target_industries_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={target_industries_id}
                                        option={{source: 'db', data: Masterbase?.target_industries}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{supply_exceeds_demand_flag.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={supply_exceeds_demand_flag}
                                        // option={{source: 'db', data: Masterbase?.position}}
                                        option={{source: 'options', section: 'status', item: 'matching'}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <CommonButton 
                                    task="search" 
                                    disabled={Action.Loading.search ? true : false}
                                    callback={(e) => onSearch(e)} 
                                />
                            </Col>                    
                        </Row>
                    </Col>
                </Row>
            </>
        )
    }
}

export default SearchMatchingDemandSupply;